import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {SpModalFacebookAccountAddComponent} from '../sp-modal-facebook-account-add/sp-modal-facebook-account-add.component';
import {FacebookLinkService} from '../../../../services/sp-facebook/facebook-link.service';
import { SessionProviderService } from 'src/app/services/sp-authentication/session-provider.service';

@Component({
  selector: 'app-sp-account-user-edit-image',
  templateUrl: './sp-account-user-edit-image.component.html',
  styleUrls: ['./sp-account-user-edit-image.component.scss']
})
export class SpAccountUserEditImageComponent implements OnInit {

  selectedImage;
  fbConnected = false;
  constructor( public dialogRef: MatDialogRef<SpModalFacebookAccountAddComponent>,
               public sessionProvider: SessionProviderService,
               private fb: FacebookLinkService,) { }

  get session() {
    return this.sessionProvider.activeSession;
  }

  ngOnInit() {
    this.fb.isLogged().then(logged => {
      this.fbConnected = logged;
    });
  }

  onImageChange(imageInput: HTMLInputElement) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {
      this.dialogRef.close(imageInput);
    });

    reader.readAsDataURL(file);
  }

  save() {
    this.dialogRef.close(true);
  }

}
